export default __webpack_public_path__ + "static/media/SE.4f15f441.svg";